'use client';

import { SmartInput } from '@web/ui';

import type { TaskSourceFilter } from '@/features/performance/types';

type TaskSourceSelectFieldProps = {
  value: TaskSourceFilter;
  onChange: (value: TaskSourceFilter) => void;
  label?: string;
  name?: string;
  disabled?: boolean;
  error?: string;
  size?: 'small' | 'medium';
};

const TASK_SOURCE_OPTIONS: { value: TaskSourceFilter; label: string }[] = [
  { value: 'all', label: 'Job & Quick Tasks' },
  { value: 'job_tasks', label: 'Job Tasks' },
  { value: 'quick_tasks', label: 'Quick Tasks' },
];

export function TaskSourceSelectField({
  value,
  onChange,
  label = 'Task Source',
  name = 'task-source',
  disabled = false,
  error,
  size = 'small',
}: TaskSourceSelectFieldProps) {
  return (
    <SmartInput
      type="select"
      name={name}
      label={label}
      size={size}
      value={value}
      options={TASK_SOURCE_OPTIONS}
      readOnly={disabled}
      error={error}
      onChange={(nextValue) => onChange(nextValue as TaskSourceFilter)}
    />
  );
}
